<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor"><i class="fa fa-truck-ramp-box text-secondary"></i> Entrada directa a Stock </h3>
    </div>
</div>

<div class="row animated fadeIn fast">


    <!-- Formulario -->
    <div class="col-12">
        <div class="card border border-info rounded">

            <div class="card-body p-2 ">

                <form class="form p-t-20"
                      [formGroup]="entradaCabeceraForm"
                      class="form-horizontal">

                    <div class="row">

                        <!-- id_cliente -->
                        <div class=" col-6">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['id_cliente'].errors }">
                                <label class="form-control-label">Cliente:</label>
                                <select formControlName="id_cliente"
                                        class="form-control"
                                        [ngClass]="{ 'form-control-danger': enviado && f['id_cliente'].errors }"
                                        (change)="getAlmacenPorDefecto()">
                                    <option *ngIf="loading"
                                            value="">Cargando...</option>
                                    <option *ngIf="!loading"
                                            value="">Selecciona...</option>
                                    <option *ngFor="let cliente of clientesList"
                                            [value]="cliente.id">
                                        {{cliente.nombre}}
                                    </option>
                                </select>

                                <div *ngIf="enviado && f['id_cliente'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['id_cliente'].errors['required']">Obligatorio</div>
                                </div>
                            </div>
                        </div>

                        <!-- albaran -->
                        <div class=" col-6">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['albaran'].errors }">
                                <label class="form-control-label">Albarán:</label>
                                <input type="text"
                                       formControlName="albaran"
                                       class="form-control"
                                       [ngClass]="{ 'form-control-danger': enviado && f['albaran'].errors }"
                                       (keyup)="toUpper('albaran')"
                                       placeholder="Albarán">
                                <div *ngIf="enviado && f['albaran'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['albaran'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['albaran'].errors['minlength']">Mínimo 4 caracteres</div>
                                    <div *ngIf="f['albaran'].errors['maxlength']">Máximo 120 caracteres</div>
                                </div>
                            </div>
                        </div>



                    </div><!-- row -->



                    <!-- Botones -->
                    <div class="row">
                        <div class="col-6">
                            <small *ngIf="almacenPorDefecto.nombre"
                                   class="text-muted">{{almacenPorDefecto.nombre}} - {{almacenPorDefecto.ubiPlaya! | mask: '00.00.00.00.00.00' }}</small>
                        </div>
                        <div class="col-6 text-right">
                            <button type="button"
                                    [disabled]="loading"
                                    class="btn btn-success px-2 px-sm-3"
                                    (click)="enviar()">
                                Añadir
                            </button>
                        </div>
                    </div>


                </form>

            </div>


        </div> <!-- card -->
    </div> <!-- col-lg-12 -->


</div>